let dates;
export function getFormattedDate(date) {
  dates = new Date(date);
  return `${dates.getFullYear()}-${dates.getMonth()}-${dates.getDate()}`;
}
const envBaseUrl = process.env.REACT_APP_API_URL?.trim();
const defaultBaseUrl =
  process.env.NODE_ENV === "production"
    ? "https://awakilo.com/api/v1"
    : "http://localhost:8080/api/v1";
export const baseUrl = envBaseUrl || defaultBaseUrl;
